import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {actions, select} from './connectors';
// components
import ShoppingCartIcon from '~/components/ShoppingCartIcon';
import ShoppingCartIcon_Lg from '~/components/ShoppingCartIcon_Lg';
import MediaQueries, {breakpoint} from '~/constants/MediaQueries';
import {formatPrice} from '~/utils/quote';
import remoteServices from '~/constants/RemoteServices';
import {metrics} from '~/vendor/metrics';
import withRouter, {routerPropTypes} from '~/router/withRouter';
import withRouteHandlers from '~/router/withRouteHandlers';
import {routeHandlersPropTypes} from '~/router/useRouteHandlers';

import './index.scss';

const propTypes = {
  cartItemCount: PropTypes.number,
  compositeIds: PropTypes.arrayOf(PropTypes.string),
  isDesignBlank: PropTypes.bool,
  isDesignDirty: PropTypes.bool,
  isMultiItemEligible: PropTypes.bool,
  routeHandlers: routeHandlersPropTypes,
  router: routerPropTypes,
  subTotal: PropTypes.number,
  updateCartItemsCategoryPaths: PropTypes.func,
  onCartClick: PropTypes.func,
  onCartHoverIn: PropTypes.func,
  onCartHoverOut: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class ShoppingCartIconWrapper extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    cartItemCount: 0,
    isDesignDirty: false,
    isDesignBlank: false,
    onCartClick: () => {},
    onCartHoverIn: () => {},
    onCartHoverOut: () => {}
  };

  state = {
    hasUpdatedItemsCategoryPaths: false
  };

  componentDidUpdate(prevProps) {
    if (
      !this.state.hasUpdatedItemsCategoryPaths &&
      this.props.cartItemCount > 0 &&
      this.props.cartItemCount !== prevProps.cartItemCount
    ) {
      this.setState({hasUpdatedItemsCategoryPaths: true});
      this.props.updateCartItemsCategoryPaths();
    }
  }

  mouseEnterHandler = () => {
    this.timeout = setTimeout(() => this.props.onCartHoverIn(), 300);
  };

  mouseLeaveHandler = () => {
    clearTimeout(this.timeout);
    this.props.onCartHoverOut();
  };

  onClickHandler = () => {
    const {cartItemCount, isDesignDirty, isDesignBlank, routeHandlers} =
      this.props;
    const cartItemsPresent = cartItemCount > 0;

    if (this.props.isMultiItemEligible) {
      metrics.fireEvent('multi item cart', 'cart icon', 'cart icon');
      this.props.onCartClick();
    } else {
      if (cartItemsPresent && (isDesignDirty || isDesignBlank)) {
        routeHandlers.shoppingCartConfirmHandler('dirty');
      } else if (cartItemsPresent) {
        const compositeIds = this.props.compositeIds.join(',');
        const url = `${remoteServices.checkout}/create_from_cart?cids=${compositeIds}`;
        window.location.assign(url);
      } else {
        routeHandlers.shoppingCartConfirmHandler('empty');
      }
    }
  };

  renderCartTotal = () => (
    <div className="ndx-ShoppingCart-subTotal">
      {formatPrice(this.props.subTotal)}
    </div>
  );

  wrapperProps = () => {
    return Object.assign(
      {
        onClickHandler: this.onClickHandler
      },
      this.props
    );
  };

  render() {
    return breakpoint(MediaQueries.largeAndAbove) ? (
      <div
        className="ndx-ShoppingCart"
        onClick={this.onClickHandler}
        onMouseEnter={this.mouseEnterHandler}
        onMouseLeave={this.mouseLeaveHandler}>
        <ShoppingCartIcon_Lg {...this.props} />
      </div>
    ) : (
      <ShoppingCartIcon {...this.wrapperProps()} />
    );
  }
}

export default connect(
  select,
  actions
)(withRouter(withRouteHandlers(ShoppingCartIconWrapper)));
